"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedType = exports.CommentEntityType = void 0;
/** The type of the parent entity. */
var CommentEntityType;
(function (CommentEntityType) {
    CommentEntityType["POST"] = "post";
    CommentEntityType["MATERIAL"] = "material";
})(CommentEntityType = exports.CommentEntityType || (exports.CommentEntityType = {}));
/** The feed type the post belongs to */
var FeedType;
(function (FeedType) {
    FeedType["ANNOUNCEMENTS"] = "announcements";
    FeedType["COMMON_ROOM"] = "commonRoom";
})(FeedType = exports.FeedType || (exports.FeedType = {}));
